// extracted by mini-css-extract-plugin
module.exports = {"table":"GoodsConferenceCategory_table__15ZMr","label":"GoodsConferenceCategory_label__3vvh8","value":"GoodsConferenceCategory_value__89XU5"};